(function (window) {
  'use strict';

  const autoScroll = document.querySelector('meta[name="autoscroll"]');
  const sliderContainer = document.querySelector('.promo-bar-slider__slider');

  function init() {
    const prevButton = document.querySelector('.promo-bar-slider__prev')
    const nextButton = document.querySelector('.promo-bar-slider__next')
    const slider = tns({
      container: sliderContainer,
      controlsContainer: null,
      items: 1,
      slideBy: 1,
      nav: false,
      loop: false,
      prevButton,
      nextButton,
      onInit: () => {
        // Forced tabindex="0" to make "prev" and "next" slider buttons keyboard accessible.
        prevButton.setAttribute('tabindex', '0')
        nextButton.setAttribute('tabindex', '0')
      }
    });
  }

  function initautoScroll() {
    const prevButton = document.querySelector('.promo-bar-slider__prev')
    const nextButton = document.querySelector('.promo-bar-slider__next')
    const slider = tns({
      container: sliderContainer,
      controlsContainer: null,
      items: 1,
      slideBy: 1,
      nav: false,
      loop: true,
      autoplay: true,
      autoplayHoverPause: true,
      autoplayTimeout: autoScroll.getAttribute("autoplaytimeout"),
      prevButton,
      nextButton,
      onInit: () => {
        // Forced tabindex="0" to make "prev" and "next" slider buttons keyboard accessible.
        prevButton.setAttribute('tabindex', '0')
        nextButton.setAttribute('tabindex', '0')
      }
    });
  }

  if (autoScroll && autoScroll.content === 'true' && sliderContainer) {
    initautoScroll()
  }else if(sliderContainer){
    init()
  }

})(this);